/* PDP gallery + size/price + sticky bar.
   Ported from the static site; product-specific bits now come from
   data attributes on .pdp so one file serves every product. */
var PDP_ROOT   = document.querySelector('.pdp');
var PDP_HANDLE = PDP_ROOT ? (PDP_ROOT.dataset.handle || '') : '';

function PDP_ADD(){
  var form = document.getElementById('pdpForm');
  if (form) form.querySelector('[type=submit]').click();
}
function PDP_WISH(add){
  if (!window.SIXTEENS_WISH || !PDP_HANDLE) return;
  var w = window.SIXTEENS_WISH.get();
  var i = w.indexOf(PDP_HANDLE);
  if (add && i === -1) w.push(PDP_HANDLE);
  if (!add && i !== -1) w.splice(i, 1);
  window.SIXTEENS_WISH.save(w);
}

document.querySelectorAll('.size-opt').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.size-opt').forEach(function(b){b.classList.remove('active');});
    btn.classList.add('active');
    document.querySelector('.price-amt').textContent=btn.dataset.price;
    var _ps=document.querySelector('.price-size');if(_ps)_ps.textContent=btn.dataset.size+' ML';
  });
});

document.getElementById('addBtn').addEventListener('click',function(){
  var active=document.querySelector('.size-opt.active');
  PDP_ADD();
});

/* ---- mobile carousel dots + sticky add-to-cart sync ---- */
(function(){
  function activeSize(){ return document.querySelector('.size-opt.active'); }
  function syncSticky(){
    var a=activeSize(); if(!a) return;
    var amt=document.getElementById('psAmt'), sz=document.getElementById('psSize');
    if(amt) amt.textContent=a.dataset.price;
    if(sz) sz.textContent=a.dataset.size+' ML';
  }
  // keep sticky price in sync when size changes
  document.querySelectorAll('.size-opt').forEach(function(b){ b.addEventListener('click',syncSticky); });
  syncSticky();

  var psAdd=document.getElementById('psAdd');
  if(psAdd) psAdd.addEventListener('click',function(){
    var a=activeSize();
    PDP_ADD();
    var old=psAdd.textContent; psAdd.textContent='Added \u2713';
    setTimeout(function(){ psAdd.textContent=old; },1200);
  });
  var psWish=document.getElementById('psWish');
  var psWish=document.getElementById('psWish');
  function reflectWish(){ if(psWish) psWish.classList.toggle('saved', window.SIXTEENS_WISH && window.SIXTEENS_WISH.has(PDP_HANDLE)); }
  reflectWish();
  if(psWish) psWish.addEventListener('click',function(){
    var a=activeSize();
    if(window.SIXTEENS_WISH && window.SIXTEENS_WISH.has(PDP_HANDLE)){ PDP_WISH(false);
      removeFromWishlist('Jaipur'); psWish.classList.remove('saved');
    } else {
      PDP_WISH(true);
      psWish.classList.add('saved');
    }
  });
})();

/* ---- filmstrip + grid: desktop 4-window slide / mobile 6-image infinite carousel ---- */
(function(){
  var visual=document.querySelector('.pdp .visual');
  if(!visual) return;
  var grads=(visual.dataset.grads||'').split('|');
  var N=grads.length;            // 6
  var WIN=4;
  var grid=document.getElementById('imgGrid');
  var gridTiles=Array.prototype.slice.call(grid.querySelectorAll('.vtile'));
  var thumbs=Array.prototype.slice.call(document.querySelectorAll('#filmStrip .fs-thumb'));
  var end=WIN-1;
  function isMobile(){ return window.matchMedia('(max-width:900px)').matches; }

  /* ----- desktop: 4-slot sliding window over 6 ----- */
  function renderDesktop(){
    for(var k=0;k<WIN;k++){
      var idx=((end-(WIN-1)+k)%N+N)%N;
      gridTiles[k].style.background=grads[idx];
      gridTiles[k].dataset.cur=idx;
    }
    thumbs.forEach(function(t){
      var i=+t.dataset.idx, inWin=false;
      for(var k=0;k<WIN;k++){ if(((end-(WIN-1)+k)%N+N)%N===i){ inWin=true; break; } }
      t.classList.toggle('active', inWin);
      t.classList.toggle('lead', i===((end%N)+N)%N);
    });
  }
  thumbs.forEach(function(t){ t.addEventListener('click',function(){ end=+t.dataset.idx; renderDesktop(); }); });

  /* ----- mobile: all 6 in an infinite-loop carousel ----- */
  var mobileBuilt=false;
  function buildMobile(){
    if(mobileBuilt) return;
    // base 6 slides + 1 clone of first appended and 1 clone of last prepended for seamless loop
    var html='';
    function slide(i){ return '<div class="vtile" data-cur="'+i+'" style="background:'+grads[i]+';"></div>'; }
    html+=slide(N-1);                     // clone of last (prepended)
    for(var i=0;i<N;i++){ html+=slide(i); } // real 0..5
    html+=slide(0);                        // clone of first (appended)
    grid.innerHTML=html;
    mobileBuilt=true;
    // build 6 dots
    var dotsWrap=document.getElementById('pdpDots');
    if(dotsWrap){ dotsWrap.innerHTML=''; for(var d=0; d<N; d++){ var sp=document.createElement('span'); sp.className='dot'+(d===0?' active':''); dotsWrap.appendChild(sp); } }
    function setDot(real){ if(!dotsWrap) return; var ds=dotsWrap.querySelectorAll('.dot'); for(var k=0;k<ds.length;k++){ ds[k].classList.toggle('active', k===real); } }
    var slides=grid.querySelectorAll('.vtile');
    var sw=function(){ return grid.clientWidth; };
    // start on the first real slide (index 1 because of prepended clone)
    grid.scrollLeft=sw();
    var raf=null, settle=null;
    function update(){
      var i=Math.round(grid.scrollLeft/sw());
      // update active dot live (no repositioning while moving)
      setDot(((i-1)%N+N)%N);
    }
    function wrapIfNeeded(){
      var i=Math.round(grid.scrollLeft/sw());
      if(i===0){ grid.style.scrollBehavior='auto'; grid.scrollLeft=N*sw(); grid.style.scrollBehavior=''; }
      else if(i===N+1){ grid.style.scrollBehavior='auto'; grid.scrollLeft=sw(); grid.style.scrollBehavior=''; }
    }
    grid.addEventListener('scroll', function(){
      if(!raf){ raf=requestAnimationFrame(function(){ update(); raf=null; }); }
      // only jump once the user has stopped scrolling (prevents fast-scroll glitch)
      if(settle) clearTimeout(settle);
      settle=setTimeout(wrapIfNeeded, 120);
    },{passive:true});
    // swipe arrows
    var aPrev=document.getElementById('pdpArrowPrev'), aNext=document.getElementById('pdpArrowNext');
    if(aPrev) aPrev.onclick=function(){ grid.scrollBy({left:-sw(),behavior:'smooth'}); };
    if(aNext) aNext.onclick=function(){ grid.scrollBy({left:sw(),behavior:'smooth'}); };
  }

  function apply(){
    if(isMobile()){ buildMobile(); }
    else {
      if(mobileBuilt){ // rebuild the 4 desktop slots
        grid.innerHTML='<div class="vtile" data-slot="0"></div><div class="vtile" data-slot="1"></div><div class="vtile" data-slot="2"></div><div class="vtile" data-slot="3"></div>';
        gridTiles=Array.prototype.slice.call(grid.querySelectorAll('.vtile'));
        mobileBuilt=false;
      }
      renderDesktop();
    }
  }
  var rz=null;
  window.addEventListener('resize', function(){ if(rz)clearTimeout(rz); rz=setTimeout(apply,200); });
  apply();
})();

/* open shared Instagram-style reel from the mini button */
(function(){
  var btn=document.getElementById('reelMini');
  if(btn) btn.addEventListener('click', function(){ if(window.openReel) window.openReel(1); });
})();

